<template>
  <v-snackbar
    v-model="added_cart"
    color="blank"
    top
    right
    timeout="5000"
    :key="cart.cart_products.length"
  >
    <div class="text-center mt-5">
      <v-badge
        bordered
        left
        :content="`${cart.cart_products.length}`"
        color="accent"
        offset-x="10"
        offset-y="10"
      >
        <img class="cart-bolsa" src="@/assets/store/iconos/bolsa.svg">
      </v-badge>
    </div>

    <v-list-item v-for="item in cart.cart_products" :key="item.id">
      <v-list-item-content>
        <v-list-item-title>
          {{ item.product.name }} x {{ item.quantity }}:
          {{ currencyFormat(item.price * item.quantity) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-right">
          Total: {{ currencyFormat(total_cart) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-btn
          color="accent"
          text
          @click="added_cart = false"
        >
          Cerrar
        </v-btn>
      </v-list-item-content>
    </v-list-item>

  </v-snackbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'

export default {
  data() {
    return {
      added_cart: false
    }
  },
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    open() {
      this.added_cart = true
    },
    currencyFormat(amount) {
      return currencyFormat(amount)
    }
  }
}
</script>
